import { safeRedirectTarget } from "~/utils/sanitize-redirect-url";
import { Outlet, useNavigate, useSearchParams } from "react-router";
import React, { useEffect, useState } from "react";
import { useUser } from "~/hooks/user";
import metrics from "~/utils/metrics";

export default function LoginWrapper() {
  const { authenticated, ...user } = useUser();
  const [params] = useSearchParams();
  const [ready, setReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      setReady(true);
      return;
    }
    // A signed-in visitor is sent on at once, so the destination gets the
    // same allowlist as a fresh sign-in (FOX-4690).
    const redirectUrl = safeRedirectTarget(params.get("redirectUrl") || "/") ?? "/";
    if (!redirectUrl.startsWith("http")) {
      navigate(redirectUrl);
    } else {
      window.location.href = redirectUrl;
    }
  }, [authenticated]);

  useEffect(() => {
    if (params.has("loggedOut")) {
      metrics.reset();
    }
  }, [params]);

  if (!ready) return null;
  return <Outlet />;
}
